import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { Formik, isNaN, useFormik } from "formik";
import * as YUP from "yup";
import { InputText } from "primereact/inputtext";
import "primeflex/primeflex.css";
import styles from "./AddProject.module.css";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
 
import {  addProjectDetails,
  editProjectDetails,
  projectById, } from "../../../services/projectService";
import Spinner from "../../../components/Spinner/spinner";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjectDetails } from "../../../store/slices/projectListSlice";
import { appInsights } from "../../../AppInsights";
const projectDetails = {
  projectTypeId: "",
  projectName: "",
  startDate: "",
  endDate: "",
  projectDescription: "",
};
export const AddProject = () => {
  const { userData } = useSelector(state => state.user);
  const currentUserTypeId = localStorage.getItem("userTypeId");
  const { projectData, loadingFlag, error, noAccess, errorCode } = useSelector(
      (state) => state.projectList
    );
  const currentUserRoleId = userData?.userTypes?.find(
      (type) => type?.userTypeId == currentUserTypeId
    );

  const roleId = currentUserRoleId?.userTypeRoleId

  
  
  const dispatch = useDispatch();
  const toast = React.useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!isNaN(Number(id))) {
      setLoading(true);
      if (!data) {
        getProjectById(id);
      } else {
        prepopulateProjectDetails(data);
      }
    }
  }, []);
 
  const getProjectById = async (id) => {
    try {
      let result = await projectById(currentUserTypeId,id);
      if (result?.projectId) {
        setData(result);
        prepopulateProjectDetails(result);
      } else {
        appInsights.trackException("Get AddProject",{ exception: error });
        setLoading(false);
        //TODO:toast
      }
    } catch (error) {setLoading(false);   toast?.current?.show({
      severity: "error",
      summary: "Error",
      detail: error?.message || error?.status == 400
      ? "Project not Found"
      : error?.status == 500
      ? "Internal Server Error"
      : error?.status ==404?"Project not Found":"Error occurred while fetching details",
      life: 5000,
    });}
  };
 
  const validationForForm = YUP.object({
    projectTypeId: YUP.string().required("Project Type is Required"),
    projectName: YUP.string()
      .required("Project Name is Required")
      .min(2,"Project Name must be at least 2 characters")
      .max(50,"Project Name must be at most 50 characters"),
    startDate: YUP.string().required("Start Date is Required"),
    endDate: YUP.string()
      .required("End Date is Required")
      .test(
        "is-greater",
        "End Date cannot be earlier than Start Date",
        function (value) {
          const { startDate } = this.parent;
          // If endDate is not selected or startDate is not selected, return true (valid)
          if (!value || !startDate) return true;
 
          // Compare the dates
          const start = new Date(startDate);
          const end = new Date(value);
 
          return end >= start; // If end date is earlier than start date, this will fail
        }
      ),
    projectDescription: YUP.string().nullable(),
  });
 
  const submitProjectData = async (form, e) => {
    try {
      let result;
      if (!formik?.isValid) return;
     
      // Add one day to both start and end dates
      const formData = {
        ...form,
        startDate: form.startDate ? new Date(new Date(form.startDate).setDate(new Date(form.startDate).getDate() )) : form.startDate,
        endDate: form.endDate ? new Date(new Date(form.endDate).setDate(new Date(form.endDate).getDate() )) : form.endDate
      };
 
      if (!e?.projectId) {
        setLoading(true);
        result = await addProjectDetails(currentUserTypeId, formData);
        formik?.resetForm();
      } else {
        setLoading(true)
        result = await editProjectDetails(currentUserTypeId, formData, data?.projectId);
      }
      toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `${result}`,
        life: 5000,
      });
    await dispatch(fetchProjectDetails(currentUserTypeId));
    setLoading(false);  
    setTimeout(() => {
      roleId==2?navigate(`/hr/project-list`):navigate("/admin/project-list");
    }, 500);
    } catch (error) {
      appInsights.trackException("Post/Edit AddProject",{ exception: error });
      setLoading(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || `Something went wrong at Server Side`,
        life: 3000,
      });
    }
    finally{
     
    }
  };
 
  const formik = useFormik({
    initialValues: projectDetails,
    validationSchema: validationForForm,
    onSubmit: (values, { resetForm }) => {
      submitProjectData(values, data);
    },
  });
  const projectTypes = [
    { name: "Internal Project", key: 1 },
    { name: "External Project", key: 2 },
  ];
 
  const prepopulateProjectDetails = (projectData) => {
    formik.setFieldValue("projectTypeId", projectData?.projectTypeId || "");
    formik.setFieldValue("projectName", projectData?.name || "");
    formik.setFieldValue(
      "startDate",
      projectData?.startDate ? new Date(projectData?.startDate) : "" || ""
    );
    formik.setFieldValue(
      "endDate",
      projectData?.endDate ? new Date(projectData?.endDate) : "" || ""
    );
    formik.setFieldValue("projectDescription", projectData?.description || "");
    setLoading(false);
  };
 
  return (
    <React.Fragment>
      {loading && <Spinner />}
      <Toast ref={toast} position="top-center" />
      {!loading && (
        <form onSubmit={formik.handleSubmit}>
          <div className="container w-100 mt-1">
            <div className="bg-white p-2 border-round-xl col-12 w-100 ">
              <div className="section-for-title px-3 ">
                <span>
                  <Button
                    icon="pi pi-arrow-left"
                    label="Project List"
                    className={`${styles?.btnProject}`}
                    onClick={() =>  roleId==2?navigate(`/hr/project-list`):navigate("/admin/project-list")}
                  />
                </span>
                <div className="pt-3 md:flex px-3 justify-content-between">
                  <div className="Start pt-1">
                    {" "}
                    <h2 className="employee_header text-black-alpha-90 font-medium m-0 pl-2 pr-3 p-1">
                      {!data ? "Create Project" : "Update Project"}
                    </h2>
                  </div>
                  <div className="end flex md:justify-content-end">
                    <span className="btn-cancel p-1">
                      <Button
                        label="Clear"
                        className="border-round-xl bg-white border-300 text-color-secondary"
                        onClick={() => formik?.resetForm()}
                      />
                    </span>
 
                    <span className="btn-create p-1">
                      <Button
                        label={`${!data ? "Create Project" : "Update Project"}`}
                        className="border-300"
                        style={{ background: "#0e2354" }}
                        type="submit"
                        disabled={!formik?.isValid}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 add-project">
            <div className="grid w-100  flex mt-1 bg-white   border-round-xl ">
              <div className="col-12 w-100 border-bottom-1  border-300">
                <span className="p-1 px-3">
                  <h2 className=" font-medium text-black-alpha-90 m-0 pl-3 pr-3 ">
                    Project Details
                  </h2>
                </span>
              </div>
              <div className="col-12 w-100">
                <div className="form-for-add-project p-4">
                  <div className="grid">
                    <div className="col-12 md:col-8 xl:col-6">
                      <label
                        htmlFor="Project Type"
                        className="text-600  block mb-2  font-semibold"
                      >
                        Project Type{" "}
                        <span className="pl-1 text-red-500">*</span>
                      </label>
                      <div className={`md:flex flex-row gap-8 bg-white surface-border border-1 border-300 border-round-lg ${styles.heightOfContainer}`}>
                        {projectTypes.map((type) => {
                          return (
                            <div
                              key={type?.key}
                              className="flex align-items-center  mt-2 md:mt-0"
                            >
                              <RadioButton
                                inputId={type.key}
                                name="projectTypeId"
                                value={type.key}
                                checked={
                                  formik.values.projectTypeId === type.key
                                }
                                onChange={formik.handleChange}
                              />
                              <label htmlFor={type.key} className="ml-2">
                                {type.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      {formik?.errors?.projectTypeId &&
                        formik?.touched?.projectTypeId && (
                          <small className="text-red-500 block pt-1">
                            {formik?.errors?.projectTypeId}
                          </small>
                        )}
                    </div>
                  </div>
 
                  <div className="grid">
                    <div className="col-10 pt-3 xl:col-10">
                      <label
                        htmlFor="Project name"
                        className="text-600 block mb-2 text-600 font-semibold"
                      >
                        Project Name{" "}
                        <span className="pl-1 text-red-500">*</span>
                      </label>
                      <InputText
                        id="name"
                        name="projectName"
                        value={formik?.values?.projectName}
                        placeholder="Project name"
                        className={styles.inputField}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik?.errors?.projectName &&
                        formik.touched.projectName && (
                          <small className="text-red-500 block pt-1">
                            {formik.errors.projectName}
                          </small>
                        )}
                    </div>
                  </div>
 
                  <div className="grid ">
                    <div className="md:col-3 mr-5 pt-3 col-12">
                      <label
                        htmlFor="Start Date"
                        className="text-600  block mb-2 text-600 font-semibold"
                      >
                       Project Start Date <span className="pl-1 text-red-500">*</span>
                      </label>
                      <Calendar
                        id="startDate"
                        name="startDate"
                        value={formik.values.startDate}
                        placeholder="Start Date"
                        className={`${styles.inputField1} ${styles["project-date-picker"]}`}
                        onChange={(e) => {
                          const selectedDate = new Date(e.value);
                          selectedDate.setHours(12, 0, 0, 0);
                          formik.setFieldValue('startDate', selectedDate);
                        }}
                        onBlur={formik.handleBlur}
                        showIcon
                      />
                      {formik.errors.startDate && formik.touched.startDate && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.startDate}
                        </small>
                      )}
                    </div>
                    <div className="md:col-3  pt-3 col-12">
                      <label
                        htmlFor="End Date"
                        className="text-600  block mb-2 text-600 font-semibold"
                      >
                      Project End Date <span className="pl-1 text-red-500">*</span>
                      </label>
                      <Calendar
                        id="endDate"
                        name="endDate"
                        value={formik.values.endDate}
                        placeholder="End Date"
                        className={`${styles.inputField1} ${styles["project-date-picker"]}`}
                        onChange={(e) => {
                          const selectedDate = new Date(e.value);
                          selectedDate.setHours(12, 0, 0, 0);
                          formik.setFieldValue('endDate', selectedDate);
                        }}
                        onBlur={formik.handleBlur}
                        minDate={
                          formik?.values?.startDate
                            ? new Date(new Date(formik?.values?.startDate).setDate(new Date(formik?.values?.startDate).getDate() + 1))
                            : null
                        }
                        showIcon
                      />
                      {formik.errors.endDate && formik.touched.endDate && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.endDate}
                        </small>
                      )}
                    </div>
                  </div>
 
                  <div className="grid">
                    <div className="pt-3 col-12 md:col-7">
                      <label
                        htmlFor="Project Description"
                        className="text-600  block mb-2 text-600 font-semibold"
                      >
                        Project Description
                      </label>
                      <InputTextarea
                        id="projectDescription"
                        name="projectDescription"
                        value={formik.values.projectDescription}
                        placeholder="Project Description"
                        className={`col-12 ,${styles.textAreaContainer}`}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.projectDescription &&
                        formik.touched.projectDescription && (
                          <small className="text-red-500 block pt-1">
                            {formik.errors.projectDescription}
                          </small>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};